import { useEffect, useRef } from "react";

const getStack = () => (window.__amBackStack = window.__amBackStack || []);

export const useBackClose = (open, onClose) => {
  const tokenRef = useRef(null);
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  useEffect(() => {
    if (!open) return;
    const stack = getStack();
    const token = {};
    tokenRef.current = token;
    stack.push(token);
    window.history.pushState({ amBack: true }, "");

    const onPop = () => {
      const s = getStack();
      if (s.length && s[s.length - 1] === tokenRef.current) {
        s.pop();
        tokenRef.current = null;
        onCloseRef.current();
      }
    };
    window.addEventListener("popstate", onPop);
    return () => {
      window.removeEventListener("popstate", onPop);
      const s = getStack();
      const i = s.indexOf(token);
      if (i >= 0) s.splice(i, 1);
      tokenRef.current = null;
    };
  }, [open]);
};
